import {List} from "@mui/material";
import {RevisionVersionDetails} from "./RevisionVersionDetails";
import React, {useContext, useEffect, useState} from "react";
import {IVersion} from "./Revisions";
import {connect} from "react-redux";
import {FirebaseContext} from "../firebase/FirebaseProvider";

interface IRevisionDetails {
    project: string
    stateKey: string
    versions: {[key: string]: IVersion}
}
function RevisionDetails({project, stateKey, versions}: IRevisionDetails) {
    const [expandedVersion, setExpandedVersion] = useState("");
    const [state, setState] = useState<any>();
    const {get} = useContext(FirebaseContext);
    const sorted = Object.keys(versions)
        .sort((lhs, rhs) => versions[rhs].created - versions[lhs].created);
    let previousVersion: IVersion;

    useEffect(() => {
        get(`nodes/${project}/${stateKey}`).then(state => setState(state));
    }, [get, project, stateKey]);
    return (
        <List sx={{flexGrow: 1}}>
            {sorted.map(versionKey => {
                const version = versions[versionKey];
                const details = <RevisionVersionDetails
                    key={versionKey} expanded={expandedVersion} previous={previousVersion} project={project}
                    setExpanded={setExpandedVersion} state={state} stateKey={stateKey} version={version}
                    versionKey={versionKey}/>

                previousVersion = version;
                return details;
            })}
        </List>
    );
}
const mapStateToProps = (store: never) => ({
});

const connected = connect(mapStateToProps, {
})(RevisionDetails);

export {connected as RevisionDetails};